import { EmployeeAvatar } from "@traas/lib/src/components/content/EmployeeAvatar";
import { getWeek } from "@traas/lib/src/util/getWeekNumber";
import { usePlanner } from "@traas/planning/src/planning/PlannerContext";
import { useOnlineEmployees } from "@traas/planning/src/realtime/OnlineEmployeesContext";
import { FC } from "react";

export const OnlineEmployeesIndicator: FC = () => {
  const { setDay } = usePlanner();
  const { onlineEmployees } = useOnlineEmployees();

  return (
    <div className={"flex-1 hidden lg:flex items-center -space-x-4 mx-2 -my-2"}>
      {onlineEmployees.map((u, k) => {
        return (
          <div className={"relative"} key={k}>
            <EmployeeAvatar employee={u} />
            {u.selectedDate && (
              <button
                className={
                  "absolute rounded-full bg-blue-800 hover:bg-blue-900 text-xs font-medium text-white top-1 right-1 flex items-center justify-center h-5 w-6 z-10"
                }
                onClick={() => setDay(u.selectedDate!)}
              >
                <span>{getWeek(u.selectedDate)}</span>
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};
